import {baseApi} from "../baseApi";
import {IAddressesResponse} from "./types";

const endpoints = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getAddresses: builder.query<IAddressesResponse, string>({
            query: (str) => ({
                url: `api/adm/addresses`,
                method: 'GET',
            }),
            providesTags: ['header']

        }),

    })
})

export const {useGetAddressesQuery} = endpoints